package com.github.jangalinski.tabweb.site

import com.github.jangalinski.tabweb._foundation.Url
import com.github.jangalinski.tabweb.icon.TabwebIcon
import com.github.jangalinski.tabweb.navigation.TabwebNavigation
import com.github.jangalinski.tabweb.navigation.TabwebNavigationElement
import com.github.jangalinski.tabweb.navigation.TabwebNavigationSection
import kotlin.collections.Iterator
import kotlin.collections.List

public data object GeneratedSiteNavigation : TabwebNavigation {
  private val elements: List<TabwebNavigationElement> = listOf(
      TabwebNavigationElement(
        title = "Home",
        description = "Documentation and things",
        route = Url("/"),
        icon = TabwebIcon.TI_HOME,
        badgeRef = "new",
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      TabwebNavigationElement(
        title = "Interface",
        route = Url("/interface"),
        icon = TabwebIcon.TI_BOX,
        children = listOf(
        TabwebNavigationElement(
        title = "Avatars",
        description = "Avatars display a photo, icon, or initials to represent a person, brand, or status.",
        route = Url("/interfaces/avatars"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Badges",
        description = "Badges highlight statuses, counts, and categories with a compact Tabweb label.",
        route = Url("/interfaces/badges"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Buttons",
        description = "Buttons invoke user actions with Tabweb colors, sizes, shapes, and icons.",
        route = Url("/interfaces/buttons"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Cards",
        description = "Cards are flexible and extensible content containers with multiple variants and options.",
        route = Url("/interfaces/cards"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Extreme cards",
        description = "Stress tests for combinations of card DSL options.",
        route = Url("/interfaces/extreme-cards"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Charts",
        description = "Chart examples rendered in Tabweb cards with ApexCharts.",
        route = Url("/interfaces/charts"),
        children = listOf(
        TabwebNavigationElement(
        title = "Chart gallery",
        description = "Chart examples rendered in Tabweb cards with ApexCharts.",
        route = Url("/interfaces/charts"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Bar charts",
        description = "The first chart family to receive a typed ApexCharts specification.",
        route = Url("/interfaces/charts/bar"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Colors",
        description = "The full color palette, with hex values, and a gradient builder.",
        route = Url("/interfaces/colors"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Tables",
        description = "Tables display information in a grid-like format of rows and columns.",
        route = Url("/interfaces/tables"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      ),
        sections = listOf(
      ),
      ),
      TabwebNavigationElement(
        title = "Infrastructure",
        route = Url("/infrastructure"),
        icon = TabwebIcon.TI_SERVER,
        children = listOf(
        TabwebNavigationElement(
        title = "Components",
        description = "Reusable UI building blocks",
        route = Url("/components"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Empty",
        description = "an empty page",
        route = Url("/empty"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Elements",
        description = "Low-level Tabweb elements",
        route = Url("/elements"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      ),
        sections = listOf(
      ),
      ),
      TabwebNavigationElement(
        title = "Plugins",
        route = Url("/plugins"),
        icon = TabwebIcon.TI_PUZZLE,
        columns = 2,
        children = listOf(
        TabwebNavigationElement(
        title = "Markdown pages",
        route = Url("/markdown-pages"),
        children = listOf(
      ),
        sections = listOf(
        TabwebNavigationSection(
        title = "Tabweb",
        elements = listOf(
        TabwebNavigationElement(
        title = "Markdown pages",
        route = Url("/markdown-pages"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Components",
        route = Url("/components"),
        children = listOf(
        TabwebNavigationElement(
        title = "Avatars",
        route = Url("/interfaces/avatars"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Badges",
        route = Url("/interfaces/badges"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Buttons",
        route = Url("/interfaces/buttons"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Cards",
        route = Url("/interfaces/cards"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Tables",
        route = Url("/interfaces/tables"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      ),
        sections = listOf(
      ),
      ),
      ),
      ),
      ),
      ),
        TabwebNavigationElement(
        title = "Marketplace",
        route = Url("/plugins/marketplace"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Installed",
        route = Url("/plugins/installed"),
        children = listOf(
        TabwebNavigationElement(
        title = "Analytics",
        route = Url("/plugins/installed/analytics"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Backups",
        route = Url("/plugins/installed/backups"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Monitoring",
        route = Url("/plugins/installed/monitoring"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Updates",
        route = Url("/plugins/updates"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Plugin settings",
        route = Url("/plugins/settings"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
        TabwebNavigationElement(
        title = "Developer tools",
        route = Url("/plugins/developer-tools"),
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      ),
        sections = listOf(
      ),
      ),
      TabwebNavigationElement(
        title = "Help",
        description = "Documentation and support",
        route = Url("/help"),
        icon = TabwebIcon.TI_HELP_CIRCLE,
        children = listOf(
      ),
        sections = listOf(
      ),
      ),
      )

  override fun iterator(): Iterator<TabwebNavigationElement> = elements.iterator()
}
